<template>
  <div class="home">
    <div
      class="banner"
      :style="[backgroundImg]"
    />
    <div class="container">
      <div class="left">
        <div
          class="left_item bg-color home-p-color"
          @click="toFestival()"
        >
          <p>{{ $t('common.p60') }}</p>
        </div>
        <div
          v-for="(item, index) in list"
          :key="index"
          class="left_item bg-color home-p-color"
          :class="{ highlight: item.id == id}"
          @click="updateData(item.id)"
        >
          <p>{{ item.name }}</p>
        </div>
      </div>
      <div>
        <div class="right bg-color home-p-color">
          <h1 class="home-color">
            {{ pasteventList.title }}
          </h1>
          <div v-html="pasteventList.content" />
          <video
            v-if="pasteventList.video"
            id="player"
            ref="video"
            autoplay
            playsinline
            controls
            loop
            style="object-fit: cover;width:100%;"
          >
            <source
              :src="pasteventList.video"
              type="video/mp4"
            >Your browser does not support the video tag.
          </video>
          <div v-html="pasteventList.second_content" />
          <h2 v-if="atlas.length">
            Atlas
          </h2>
          <swiper :options="swiperOption">
            <swiper-slide
              v-for="atla of atlas"
              :key="atla"
            >
              <img
                class="ui image"
                :src="atla"
                alt
              >
            </swiper-slide>
            <!-- <div class="swiper-pagination" slot="pagination"></div> -->
          </swiper>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { getFestivalHistoryMatch } from '@/api/official'

export default {
  components: {
    swiper,
    swiperSlide
  },
  data () {
    return {
      list: [],
      game: {},
      swiperOption: {
        slidesPerView: 'auto',
        spaceBetween: 30
        // pagination: {
        //   el: '.swiper-pagination',
        //   clickable: true
        // }
      },
      light: {
        taiwan: {},
        japan: {}
      },
      backgroundImg: '',
      // mobileImg: '',
      atlas: [],
      bigAtlas: [],
      city: '',
      id: 1,
      pasteventList: {}
    }
  },
  created () {
    this.id = this.$route.params.id
    this.$store.commit('changeTab', '/events')
    this.initData()
  },
  mounted () {
    document.querySelector('#app').scrollIntoView({ block: 'start', behavior: 'smooth' })
  },
  methods: {
    initData: function () {
      getFestivalHistoryMatch({ id: this.$route.params.id })
        .then(res => {
          this.pasteventList = res.data.list.map(v => {
            return {
              ...v.lang[this.$i18n.locale], id: v.id, headImage: v.headImage, bannerImage: v.bannerImage.pc
            }
          })[0]

          this.backgroundImg = {
            backgroundImage:
              'url(' + this.pasteventList.bannerImage + ')'
          }

          this.atlas = res.data.list[0].picture.map(v => {
            return v.pcShortcut
          })
          this.bigAtlas = res.data.list[0].picture.map(v => {
            return v.pc
          })
        })

      getFestivalHistoryMatch()
        .then(res => {
          this.list = res.data.list.map(v => {
            return { name: v.lang[this.$i18n.locale].title, id: v.id }
          })
        })
    },
    updateData (id) {
      // this.$router.push({ name: 'festival-past', params: { id } })
      // this.id = id
      // this.initData()
      window.open('/festival/past/' + id)
    },
    toFestival () {
      this.$router.push({ name: 'festival' })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.home{
  position: relative;
  padding: 0px 0px 65px 0px;
  min-width: 1200px;
  .banner {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: top;
    margin: 0;
    height: 410px;
    // background-image: url("/official/static/img/festival_city/pc_japan.jpg");
    margin-bottom: 65px;
  }
  .container {
    display: flex;
    justify-content: space-around;
    align-items: flex-start;
  }
  .left {
    position: relative;
    display: inline-block;
    width: 224px;
    .left_item {
      width: 200px;
      padding: 0 10px;
      height: 55px;
      margin-bottom: 2px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      p {
        font-size: 15px;
        text-align: center;
        max-width:100%;
      }
    }
    .highlight {
      background-color: #58b26d;
      color: #fff;
    }
  }
  .right {
    position: relative;
    width: 868px;
    display: inline-block;
    padding: 52px 44px;
    h1 {
      font-size: 46px;
      margin-bottom: 6px;
      margin: 0px 0px 20px 0px;
    }
    h2 {
      margin-top: 30px;
      font-size: 38px;
      margin-bottom: 10px;
    }
    /deep/p {
      font-size: 16px;
      margin: 0px;
      line-height: 24px;
      span {
        color: #828282!important;
      }
      a {
        color: #1f9d56;
      }
    }
    /deep/a {
      color: #1f9d56;
    }
    .images_grid {
      margin-top: 28px;
    }
    .big-image {
      max-width: 100%;
    }
    .swiper-slide {
      width: 350px;
    }
  }

}
</style>
